import { User } from '@/types';
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const authUserSlice = createSlice({
  name: 'authUser',
  initialState: null as User | null,
  reducers: {
    setAuthUser: (state, action: PayloadAction<User | null>) => {
      return action.payload;
    },
  },
});

export const { setAuthUser } = authUserSlice.actions;

export default authUserSlice.reducer;
